import {
  currentOrPastDateUI,
  fullNameUI,
  ssnUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validateDateRange } from 'platform/shared/health-apps';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['household-info--spouse-basic-info-title'];
const DESC_TEXT = content['household-info--spouse-basic-info-description'];
const INPUT_LABELS = {
  name: content['household-info--spouse-basic-info-name-label'],
  ssn: content['household-info--spouse-basic-info-ssn-label'],
  dob: content['household-info--spouse-basic-info-birthdate-label'],
  marriage: content['household-info--spouse-basic-info-marriage-date-label'],
};

const {
  dateOfMarriage,
  spouseDateOfBirth,
  spouseFullName,
  spouseSocialSecurityNumber,
} = FULL_SCHEMA.properties;

const VALIDATIONS = [
  validateDateRange({
    startDateKey: 'spouseDateOfBirth',
    endDateKey: 'dateOfMarriage',
    rangeErrorMessage: content['validation-error--marriage-date-range'],
  }),
];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    spouseFullName: fullNameUI(title => `${INPUT_LABELS.name} ${title}`),
    spouseSocialSecurityNumber: ssnUI(INPUT_LABELS.ssn),
    spouseDateOfBirth: currentOrPastDateUI(INPUT_LABELS.dob),
    dateOfMarriage: currentOrPastDateUI(INPUT_LABELS.marriage),
    'ui:validations': VALIDATIONS,
  },
  schema: {
    type: 'object',
    required: [
      'spouseFullName',
      'spouseSocialSecurityNumber',
      'spouseDateOfBirth',
      'dateOfMarriage',
    ],
    properties: {
      spouseFullName,
      spouseSocialSecurityNumber,
      spouseDateOfBirth,
      dateOfMarriage,
    },
  },
};
